import React from 'react';
import {
    Modal,
    Input,
    Form,
    Select,
    Tabs,
    Table
} from 'antd';


const InputGroup = Input.Group;
const { Search } = Input;
const { Option } = Select;
const { TabPane } = Tabs;

class FormModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleCancel = () => {
        this.props.onClose();
    }

    render() {
        const { getFieldDecorator, setFieldsValue, getFieldValue } = this.props.form;
        return (
            <Modal
                title={"Ver Receta de Producción"}
                visible={this.props.visible}
                cancelText={"Cerrar"}
                onCancel={this.handleCancel}
                onOk={this.handleCancel}

                style={{ top: 30 }}
                width="750px"
            >
                <Form>
                    {getFieldDecorator('id', { initialValue: this.props.formValues.id })(
                        <input type="hidden" />
                    )}
                    <div className="row">
                        <div className="col-md-4 form-group">
                            <Form.Item label="Serie / Documento">
                                <InputGroup compact>
                                    <Form.Item style={{ width: '40%' }}>
                                        <Input
                                            placeholder="Serie"
                                            autoComplete="off"
                                            className="first-input"
                                            value={this.props.formValues.serie}
                                            readOnly
                                        />
                                    </Form.Item>
                                    <Form.Item style={{ width: '60%' }}>
                                        <Input
                                            placeholder="Documento"
                                            autoComplete="off"
                                            className="second-input"
                                            value={this.props.formValues.documento}
                                            readOnly
                                        />
                                    </Form.Item>
                                </InputGroup>
                            </Form.Item>
                        </div>

                        <div className="col-md-8 form-group">
                            <Form.Item label="Producto Terminado" >
                                {getFieldDecorator('idProducto', {
                                    initialValue: this.props.formValues.idProducto ?
                                        { key: this.props.formValues.idProducto } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione producto terminado"}
                                        optionFilterProp="children"
                                        disabled={true}
                                    >
                                        {this.props.formValues.productos.map(item => (
                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                        ))}
                                        
                                    </Select>
                                )}
                                
                            </Form.Item>
                        </div>



                    </div>


                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="Descripción">
                                {getFieldDecorator('descripcion', {
                                    initialValue: this.props.formValues.descripcion,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                        whitespace: true
                                    }]
                                })(
                                    <Input
                                        placeholder="Ingresar Descripcion"
                                        autoComplete="off"
                                        readOnly
                                    />
                                )}
                            </Form.Item>
                        </div>

                    </div>

                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Tabs >

                                <TabPane tab="Insumos" key="1">
                                   
                                   
                                    <Table
                                        className={'table-producto'}
                                        scroll={{ x: true }}
                                        size="small"
                                        style={{ overflowX: 'auto' }}
                                        pagination={false}
                                        dataSource={this.props.formValues.listaComprobanteDetalle}
                                        rowKey={record => record.idProducto}
                                
                                        columns={[
                                            {
                                                title: 'Insumo',
                                                dataIndex: 'idProducto',
                                                key: 'idProducto',
                                                render: (value, row) => {
                                                    return (
                                                        <Form.Item >
                                                         <span>{row.nombre}</span>
                                                        </Form.Item>
                                                    );
                                                }
                                            },
                                            {
                                                title: 'Unidad de Medida',
                                                dataIndex: 'nombreUnidadMedida',
                                                key: 'nombreUnidadMedida',
                                       
                                            },
                                            {
                                                title: 'Cantidad',
                                                dataIndex: 'cantidad',
                                                key: 'cantidad',
                                                align: 'center',
                                                width: 90,
                                                render: (value, row) => {
                                                    return (
                                                        <Form.Item>
                                                        <span>{row.cantidad}</span>
                                                        </Form.Item>
                                                    );
                                                }
                                            },

                                        ]}
                                    />
                                </TabPane>

                            </Tabs>
                        </div>
                    </div>


                </Form>
            </Modal>
        );
    }
}
export default Form.create()(FormModal)